<template>
  <v-container class="fill-height">
    <v-row
      class="fill-height pb-7"
      align="center"
      justify="center"
    >
      <div class="loader-container">
        <div class="nb-spinner"></div>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 311.75 255.06" class="loading-mappa-logo">
          <polygon class="loading-cls-1" points="0 177.13 155.88 99.18 311.75 177.11 155.88 255.06 0 177.13"></polygon>
          <polygon class="loading-cls-2" points="0 126.61 155.88 48.69 311.75 126.62 155.88 204.54 0 126.61"></polygon>
          <polygon class="loading-cls-3" points="0 77.93 155.88 0 311.75 77.94 155.88 155.86 0 77.93"></polygon>
        </svg>
        <div class="display-1 accent--text loading-text">Carregando</div>
      </div>
    </v-row>
  </v-container>
</template>

<script>
  import anime from "animejs"

  export default {
    name: "LoadingScreen",
    methods: {
      startAnimation() {
        const firstLayer = "#16afdd"
        const secondLayer = "#0097bf"
        const thirdLayer = "#00779f"

        anime.timeline({
          easing: "easeInOutQuad",
          loop: true,
          duration: 2000,
        }).add({
          targets: ".loading-cls-3",
          keyframes: [
            {fill: thirdLayer},
            {fill: secondLayer},
            {fill: firstLayer},
          ],
        }).add({
          targets: ".loading-cls-2",
          keyframes: [
            {fill: firstLayer},
            {fill: thirdLayer},
            {fill: secondLayer},
          ],
        }, 0).add({
          targets: ".loading-cls-1",
          keyframes: [
            {fill: secondLayer},
            {fill: firstLayer},
            {fill: thirdLayer},
          ],
        }, 0)

      },
    },
    mounted() {
      this.startAnimation()
    },
  }
</script>

<style scoped lang="scss">
  .loading-cls-1 {
    fill: #00779f;
  }

  .loading-cls-2 {
    fill: #0097bf;
  }

  .loading-cls-3 {
    fill: #16afdd;
  }

  .loader-container {
    position: relative;
    height: 250px;
    width: 250px;
  }

  .loading-text {
    position: absolute;
    left: 50%;
    top: 100%;
    transform: translate(-50%, 10%);
  }

  .loading-mappa-logo {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 175px;
  }

  .nb-spinner {
    position: absolute;
    top: 0;
    left: 0;

    width: 250px;
    height: 250px;
    margin: 0;
    background: transparent;
    border-top: 2px solid rgba(59, 74, 119, .4);
    border-right: 2px solid transparent;
    border-radius: 50%;
    -webkit-animation: 2.3s spin linear infinite;
    animation: 2.3s spin linear infinite;
  }

  @-webkit-keyframes spin {
    from {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @keyframes spin {
    from {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>
